import {useUp} from 'quickstart/system'
import {logger} from 'tizra'

const log = logger('quickstart/hooks/useMobile')

export const useMobile = (userAgent?: string) => {
  // iPad doesn't have "iPhone," and Android tablet doesn't have "Mobile"
  const isMobileUserAgent = /\biPhone\b|\bAndroid\b.*\bMobile\b/.test(
    userAgent || '',
  )
  const isDesktop = useUp('lg', !isMobileUserAgent)
  return !isDesktop
}
